import {
    IComparisonBoardClientSnapshot,
    IComparisonBoardItem,
} from '../../../interfaces/comparison-boards/IComparisonBoards';

const normalizeText = (value: unknown) => String(value || '').trim();

const getClientLabelFromValue = (
    value?: string | IComparisonBoardClientSnapshot,
) => {
    if (!value) return '';
    if (typeof value === 'string') return normalizeText(value);

    return normalizeText(
        value.username
        || value.companyData?.username
        || value.client?.username
        || value.client?.companyData?.username
        || value.companyName
        || value.companyData?.companyName
        || value.name
        || value.companyData?.name
        || value.email,
    );
};

export const getComparisonBoardId = (row: IComparisonBoardItem) =>
    normalizeText(row._id || row.id);

export const getComparisonBoardClient1 = (row: IComparisonBoardItem) =>
    normalizeText(
        getClientLabelFromValue(row.mainAccount)
        || row.client1Username
        || row.clientOneUsername
        || getClientLabelFromValue(row.client1)
        || getClientLabelFromValue(row.clientOne),
    ) || '--';

export const getComparisonBoardClient2 = (row: IComparisonBoardItem) =>
    normalizeText(
        getClientLabelFromValue(row.clonedAccount)
        || row.client2Username
        || row.clientTwoUsername
        || getClientLabelFromValue(row.client2)
        || getClientLabelFromValue(row.clientTwo),
    ) || '--';

export const isComparisonBoardClone = (row: IComparisonBoardItem) =>
    Boolean(row.clonedAccount || (row.clone ?? row.cloned));

export const isComparisonBoardEnabled = (row: IComparisonBoardItem) =>
    typeof row.linkedAccount?.active === 'boolean'
        ? row.linkedAccount.active
        : typeof row.enabled === 'boolean'
            ? row.enabled
            : true;

export const getComparisonBoardActiveClientId = (row: IComparisonBoardItem) =>
    normalizeText(
        row.linkedAccount?.clonedLinkedTo?._id
        || row.linkedAccount?.mainLinkedTo?._id
        || row.mainAccount?._id
        || row._id
        || row.id,
    );
